import { render, staticRenderFns } from "./PayableDetailContent.vue?vue&type=template&id=6fedb525&"
import script from "./PayableDetailContent.vue?vue&type=script&lang=js&"
export * from "./PayableDetailContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports